import './assets/css/App.css';

function App() {
  return (
    <div className="wrapper">
        <div className="paper-filter"></div>
        <svg>
            <filter id='roughpaper'>
                <feTurbulence type="fractalNoise" baseFrequency='0.04' result='noise' numOctaves="5" />

                <feDiffuseLighting in='noise' lighting-color='#fff' surfaceScale='2'>
                    <feDistantLight azimuth='45' elevation='60' />
                </feDiffuseLighting>
            </filter>
        </svg>
        <div style={{textAlign:"center"}}>
            <img
                style={{
                    width: "100%",
                    height: "auto",
                    maxWidth: "18vw",
                    margin: "10px 0",
                }}
                alt="Coors logo"
                src={require("./assets/images/coorslight_logo.webp")}
            />

            <h1>
                <div className="half-1">Get Ready to</div>
                <div className="half-2">BottleRock</div>
            </h1>
            <div className="body-text">
                <h4>We're hooking you up with a VIP BottleRock experience from our Coors Light Suite</h4>
                <p>
                    Get ready for a stellar lineup with a great view of the main stage, food, an open bar, access to premium bathrooms and VIP access at all other stages.
                </p>
                <p>
                    If you're staying at the Napa Marriott, please enjoy access to our shuttle that goes from the hotel to the festival every 15 minutes each day.
                </p>
                <p>
                    And there's more. We hope you'll join us for an epic welcome party at the Marriott on Thursday night. You won't want to sleep on it!
                </p>
            </div>
            
        </div>
        

        <div style={{textAlign:"center"}}>
            <div className="iframe-box">
                <iframe
                    src="https://player.vimeo.com/video/823909244?h=1519d6d805&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                    frameBorder="0"
                    allowFullScreen
                    style={{position:"absolute",top:0,left:0,width:"100%",height:"100%"}}
                    title="Media1"
                />
            </div>
        </div>
        
        <div className="footer-img-grid">
            <img
                alt="Blue Moon Light Sky can"
                src={require("./assets/images/light-sky.png")}
            />
            
            <img
                alt="Coors Light chill cheers"
                src={require("./assets/images/coors-light.png")}
            />
            
            <img
                alt="Hop Valley stand"
                src={require("./assets/images/hop-valley.png")}
            />
        </div>
        
        <footer>
            <a href="https://www.canarymarketing.com" target="_blank" rel="noreferrer">Powered by Canary</a>
        </footer>
    </div>
  );
}

export default App;
